module.exports = __webpack_public_path__ + "img/afther-1.a390da00.png";